import React, {createContext, ReactNode, useCallback, useContext, useEffect, useState} from "react";
import {getSource} from "../../components/requests";
import {useAuth} from "./AuthContext";

type HeaderContextType = {
  lastSearch: string;
  setLastSearch: (title: string) => void;
  title: string;
  setTitle: (title: string) => void;
  sources: any;
};

export const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

// Pour conserver la dernière recherche global de l'utilisateur
export const HeaderProvider: React.FC<{ children: ReactNode }> = ({children}) => {
  const {currentUser} = useAuth();
  const [lastSearch, setLastSearch] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [sources, setSources] = useState<any>([]);

  // Méthode d'obtention des sourcesau premier chargement de la page
  const getSources = useCallback(() => {
    if (currentUser && sources.length === 0) {
      getSource()
        .then(response => {
          if (response.status === 200 && response.data !== undefined) {
            setSources(response?.data?.member?.map((data) => ({
              id: data?.id,
              libelle: data?.libelle
            })));
          }
        })
        .catch(error => console.error(error));
    }
  }, [currentUser, sources]);

  useEffect(() => {
    getSources();
  }, [getSources]);

  return (
    <HeaderContext.Provider
      value={{
        lastSearch,
        setLastSearch,
        title,
        setTitle,
        sources,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
}

export const useHeader = () => {
  const ctx = useContext(HeaderContext);
  if (!ctx) throw new Error("useHeader must be used inside HeaderContext");
  return ctx;
};